// extracted by mini-css-extract-plugin
module.exports = {"date":"styles_date__1pLat","label":"styles_label__32Nsz","error":"styles_error__2Kxwt"};